{
  "previous": "Назад",
  "next": "Далі",
  "complete": "Завершити",
  "verifyAndCheckIn": "Підтвердити та зареєструватися",
  "loading": {
    "retrievingLocation": "Визначення місцезнаходження...",
    "retrievingWarehouse": "Завантаження даних складу..."
  },
  "validation": {
    "fieldRequired": "Це поле є обов'язковим",
    "fieldRequiredWithLabel": "Поле «{label}» є обов'язковим",
    "phoneInvalid": "Невірний номер телефону",
    "phoneInvalidWithExample": "Невірний номер телефону (приклад: {example})"
  }
}
